import { ReactNode } from 'react';
import { FormApi } from 'final-form';
import { IApiResponse } from 'utils/models';

type fileUpload = {
  name: string;
  size: number;
};

export type FormType = FormApi<IFormValues, Partial<IFormValues>>;

export const sortArrays = [
  'Source Account:',
  'Number of Transactions:',
  'Principal Amount:',
  'ELevy Fee:',
  'Transaction Fee:',
  'Amount:',
];

export const bulkDataConfig = {
  sourceAccount: 'Source Account:',
  numberOfTransactions: 'Number of Transactions:',
  principalAmount: 'Principal Amount:',
  totalAmount: 'Total Amount:',
  ELevyFee: 'ELevy Fee:',
  TransactionFee: 'Transaction Fee:',
};

export const bulkSortArray = [
  'Source Account:',
  'Number of Transactions:',
  'ELevy Fee:',
  'Transaction Fee:',
  'Principal Amount:',
  'Total Amount:',
];

export interface IFormValues {
  networkCode: string;
  sourceAccount: string;
  phoneNumber: string;
  narration: string;
  amount: number;
  totalAmount: number;
  charge: number;
  file: fileUpload[];
}

export interface ITransactionField {
  label: ReactNode;
  value: ReactNode;
}
export interface IMobileMoneyResponse extends IApiResponse {
  transactionId: number;
}
export interface IBulkUploadData extends IApiResponse {
  bulkUploadData: IBulkDataList[];
  elevy: number;
  charge: number;
}

export interface IBulkDataList {
  sourceAccount: string;
  netWork: string;
  beneficiaryWalletNumber: string;
  walletName: string;
  beneficiaryName: string;
  description: string;
  narration: string;
  amount: string;
  eleveyFee: number;
  eleveyId: string;
  charge: number;
  code: number;
}

export interface IBulkTransferData {
  amount: number | string;
  phoneNumber: string;
  narration: string;
  walletName: string;
  elevyFee: number | string;
  networkCode: string;
  SaveBen: boolean;
}
export interface IBulkTransferBody {
  sourceAccount: string;
  passwordType: string;
  password: string;
  bulkTransferData: IBulkTransferData[] | string;
}
